/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1noh358{row-gap:var(--spacingVerticalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkfq4zb{color:var(--colorNeutralForeground2);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f11d4kpn{color:var(--colorNeutralForeground3);}
.fy9rknc{font-size:var(--fontSizeBase200);}
.f175fatz{max-inline-size:160px;}
/** @griffel:css-end **/